export const HEIGHTS = {
  "short":  "320",
  "medium": "490",
  "tall":   "688"
}
